import React from 'react'
import { useTranslation } from 'react-i18next'
import useStyles from './GenericError.styles'

export const GENERIC_ERROR_TESTID = 'generic-error-testid'

const GenericError: React.FC = () => {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <div className={classes.root} data-test={GENERIC_ERROR_TESTID}>
      {t('recall_generic_error')}
    </div>
  )
}

export default GenericError
